module.exports = "../images/newsletter-banner@2x.jpg?v=246acb4";